import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import Flex from '../../../bui/elements/flex'

customElements.define('k-hero', class extends LitElement{

    static properties = {
        img: {type: String},
        pos: {type: String}
    }

    static styles = css`

        :host([hidden]) { display: none; }

        :host {
            display: block;
            height: 60vh;
            width: 100vw;
            position: relative;
            margin: -3em auto 0;
            left: 50%;
            transform: translateX(-50%);
            z-index: -1;
            margin-bottom: 1em;
        }

        @media (max-width: 599px) {
            :host {
                height: 50vh;
                margin-bottom: 2em;
            }
        }

        :host {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 1fr;
        }

        :host ::slotted(h1) {
            text-wrap: balance;
        }

        :host > * {
            grid-column: 1;
            grid-row: 1;
        }

        :host .content {
            z-index: 100;
            display: grid;
            align-items: center;
            align-self: center;
            justify-items: flex-start;

            max-width: var(--max-w);
            padding: 0 var(--content-pad);
            justify-self: center;
            width: 100%;
            box-sizing: border-box;
        }

        slot{ 
            display: block;
            min-height: 0;
        }

        [name="img"] img,
        [name="img"] video,
        [name="img"]::slotted(img) {
            min-height: 0;
            min-width: 0;
            height: 100% !important;
            width: 100vw !important;
            object-fit: cover;
            object-position: center var(--hero-img-pos, center);
        }

        :host > img.mountains {
            position: absolute;
            bottom: -5px;
            left: 0;
            z-index: 100;
            height: auto !important;
            transform: scaleY(.5);
            transform-origin: bottom;
        }

        @media (max-width: 999px) {
            :host > img.mountains {
                transform: none;
            }
        }

        .overlay {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(0, 0, 0, .5) 0%, rgba(155, 82, 224, 0) 70%),
                linear-gradient(to bottom, transparent, rgba(155, 82, 224, 0) 80%, rgba(0, 0, 0, .5) 100%);
            background: linear-gradient(180deg, rgba(0, 0, 0, .5) 0%, rgba(155, 82, 224, 0) 70%);

            background: linear-gradient(180deg, rgba(0, 0, 0, .5) 10%, rgba(155, 82, 224, 0) 30%);
            top: 0;
            left: 0;   
        }
    `

    updated(){
        this.style.setProperty('--hero-img-pos', this.pos)
    }

    firstUpdated(){
        this.classList.toggle('hero', !this.hidden)
    }

    get isVideo(){ return this.img?.match?.(/.mp4$/)}

    render(){return html`
        
        <slot name="img">
        ${this.isVideo?this.renderVideo():unsafeHTML(this.img)}
        </slot>
    
        <img src="/wp-content/themes/theme/imgs/mountain-range.svg" class="mountains">
        
        <div class="content">
            <slot></slot>
        </div>

        <div class="overlay"></div>
    `}

    renderVideo(){ return html`
        <video autoplay playsinline muted loop _poster="">
            <source src="${this.img}" type="video/mp4">
        </video>
    `}

    set hidden(val){
        super.hidden = val
        this.classList.toggle('hero', !this.hidden)
    }
    
    get hidden(){ return super.hidden }

})

export default customElements.get('k-hero')

// import { LitElement, html, css } from 'lit'

customElements.define('k-hero-content', class extends Flex{

    static styles = [Flex.styles, css`
        :host ::slotted(*) {
            font-family: var(--font-header);
            background: rgb(from var(--color, #fff) r g b / .8);
            line-height: 1em;
            display: inline-block;
            padding: .5rem .75rem !important;
            margin: 0 !important;
            text-transform: uppercase;
            text-wrap: balance;

            clip-path: polygon(1% 0, 100% 0, 99% 100%, 0 100%);
        }  

        ::slotted(h3) {
            --color: var(--orange);
            color: white !important;
            text-transform: none !important;
            font-weight: normal !important;
        }
    `]

    render(){return html`
        <slot></slot>
    `}

})

// export default customElements.get('k-hero-content')